<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" :id="id">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" :data-parent="'#'+id">
                <div class="card-body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
export default {
    props: {
        id: {
            default: 'filterBar'
        }
    }
}
</script>

<style>

</style>